<script>
export default {
  data() {
    return {
      forms: []
    };
  }
};
</script>

<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<style scoped>
#all-form-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
el-menu-item {
  width: 100px;
  height: 100px;
  border: 1px solid;
}
</style>